import React from 'react';

import Typography from '@mui/material/Typography';

import GeswebLink from 'components/Shared/GeswebLink';

type Sequence = {
    NUMSEQ?: string;
    TYPBONVTE?: string;
    GENBON?: string;
    GENFAC?: string;
    DATBON?: string;
};

type OutRecent = {
    CLE?: string;
    ETAT?: string;
    // Gescom : le tableau des séquences peut arriver sous « SEQ » (observé) ou « SEQs » (spec initiale).
    // On tolère les deux en attendant confirmation de l'équipe Gescom.
    SEQ?: Sequence[];
    SEQs?: Sequence[];
};

type Props = {
    // Soit le MessageJson complet reçu de Gescom, soit une simple clé RECENT.
    value?: string | null;
};

// Libellé lisible de l'état RECENT (champ ETAT du message Gescom).
const libelleEtat = (etat?: string): string => {
    switch (etat) {
        case '1': return 'En attente';
        case '2': return 'À intégrer';
        case '3': return 'En erreur';
        case '4': return 'Intégré';
        default: return etat ?? '';
    }
};

/**
 * Affichage formaté d'une réclamation sur bon de vente (RECENT) à partir de son JSON Gescom.
 * `value` peut être le MessageJson complet ou une simple clé. Tant qu'aucun message n'est reçu,
 * on affiche l'attente. Composant partagé (historique dossier + administration).
 */
export default function ReclamationSurBonDeVenteDetail({ value }: Props) {

    if (!value) {
        return (
            <Typography variant="body2" gutterBottom>
                Réclamation sur bon de vente déclenchée, en attente de retour de Gescom.
            </Typography>
        );
    }

    // Valeur non-JSON (ne commence pas par '{') → clé RECENT simple → lien Gesweb seul.
    const estJson = value.trimStart().startsWith('{');
    if (!estJson) {
        return (
            <Typography variant="body2" gutterBottom>
                Clé : <GeswebLink mode="button" label={value} structure="recent" cle={value} environment={null} />
            </Typography>
        );
    }

    let message: OutRecent;
    try {
        message = JSON.parse(value) as OutRecent;
    } catch (e) {
        // JSON illisible : affichage brut de secours.
        return <Typography variant="body2" gutterBottom>{value}</Typography>;
    }

    const seq = message.SEQ ?? message.SEQs;
    const sequences: Sequence[] = Array.isArray(seq) ? seq : [];

    return (
        <div>
            {message.CLE && (
                <Typography variant="body2" gutterBottom>
                    Clé : <GeswebLink mode="button" label={message.CLE} structure="recent" cle={message.CLE} environment={null} />
                </Typography>
            )}

            {message.ETAT && (
                <Typography variant="body2" gutterBottom>État : {libelleEtat(message.ETAT)}</Typography>
            )}

            {sequences.length > 0 && (
                <ul>
                    {sequences.map((s, index) => (
                        <li key={index}>
                            <Typography variant="body2" component="span">{s.TYPBONVTE} : {s.GENBON}</Typography>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
